// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// Built off of https://vuejs-templates.github.io/webpack/

import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import Snotify, { SnotifyPosition } from "vue-snotify";
import VeeValidate from "vee-validate";
import VCalendar from "v-calendar";
import Paginate from "vuejs-paginate";
import hiddenExcluded from "../static/resources/Rules/hiddenExcluded";
import VueSlider from "vue-slider-component";
import erroren from "../static/resources/Errors/error-en";
import Print from "vue-print-nb";
import tinymce from '@/lib/tinymce/tinymce.js';

// Http Request Library
import "font-awesome/css/font-awesome.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.min.css";
import "vue-snotify/styles/material.css";
import "v-calendar/lib/v-calendar.min.css";
import "vue-slider-component/theme/default.css";
import "../styles/main.scss";

// Show Production Tip if in Development
Vue.config.productionTip = process.env.NODE_ENV == "development";

// Ignore the following custom elements
Vue.config.ignoredElements = ["tableau-viz", "viz-filter"];

// Setup Axios
Vue.http = Vue.prototype.$http = axios.create({
  baseURL: process.env.MOTOFUZE_API
});

Vue.http.interceptors.request.use(async function(config) {
  config.headers = {
    Authorization: store.getters.AuthorizationHeader
  };
  return config;
});

Vue.use(BootstrapVue);
Vue.use(Print);

// Setup pagination component
Vue.component("paginate", Paginate);

// Setup Vue-Snotify for notifications
const options = {
  toast: {
    position: SnotifyPosition.leftBottom, // PX-10665
    titleMaxLength: 200,
    bodyMaxLength: 500,
    showProgressBar: false
  }
};
Vue.use(Snotify, options);
Vue.component("VueSlider", VueSlider);

Vue.use(VCalendar, {
  firstDayOfWeek: 1
});

Vue.use(VeeValidate, { locale: "en", dictionary: erroren });
VeeValidate.Validator.extend("hiddenExcluded", hiddenExcluded);

/* Setup tinymce editor */
tinymce.loadScripts();

// Load training script
if (!document.getElementById("aa-training-root-script")) {
  var trainingScript = document.createElement("script");
  trainingScript.id = "aa-training-root-script";
  trainingScript.type = "text/javascript";
  trainingScript.language = "javascript";
  trainingScript.async = true;
  trainingScript.src = "https://cdn.whatfix.com/prod/b3d0c6ab-8f0e-4f4d-988a-b4c0374428e0/initiator/initiator.nocache.js";
  var bodyElements = document.getElementsByTagName("body");
  if (bodyElements && bodyElements.length > 0) bodyElements[0].appendChild(trainingScript);
}

/* eslint-disable no-new */

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js